module.exports = __webpack_public_path__ + "static/media/global-preferences-notifications.c14a1555.svg";